module.exports = __webpack_public_path__ + "img/02.be7917b4.png";